<template>
  <div class="totem-save-form" data-block-interaction>
    <h1>We're balancing your Hopes!</h1>
    <!-- <h2 class="gray">How would you like to call your Hope Sculpture?</h2> -->
    <div><el-input @focus="onInputFocus" @blur="onInputBlur" placeholder="What’s your name?" v-model="name"></el-input></div>
    <!-- <h2 class="gray">Where do you want it to land?</h2> -->
    <div><el-input @focus="onInputFocus" @blur="onInputBlur" placeholder="Where are you now?" v-model="location" ref="placeInput"></el-input></div>
    <div class="error" v-if="error && error.response && error.response.data"><div v-for="(detail, index) in error.response.data.details">{{detail.message}}</div></div>
    <el-button class="done-btn" @click="onSaveClick" :disabled="!validForm">DONE</el-button>
  </div>
</template>

<script>
/* global google */
import GoogleHopeService from '@/services/GoogleHopeService'
import ElButton from 'element-ui/packages/button'
import ElInput from 'element-ui/packages/input'
import to from 'await-to-js'

export default {
  name: 'TotemSaveForm',
  components: {
    ElButton,
    ElInput
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    concepts: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      name: '',
      location: '',
      latitude: null,
      longitude: null,
      error: null
    }
  },

  mounted: function () {
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs['placeInput'].$el.children[0], {types: ['geocode']})
    this.autocomplete.addListener('place_changed', this.fillInAddress)
  },

  beforeDestroy: function () {
    this.autocomplete.unbindAll()
    google.maps.event.clearInstanceListeners(this.$refs['placeInput'].$el.children[0])
    // google.maps.event.removeListener(this.fillInAddress)
  },

  computed: {
    validForm: function () {
      return this.name !== '' && this.location !== '' && this.name.length > 1 && this.latitude !== null && this.longitude !== null
    }
  },

  methods: {
    onInputFocus (ev) {
      this.$emit('input:focus')
    },
    onInputBlur (ev) {
      this.$emit('input:blur')
    },
    onSaveClick: async function () {
      this.error = null
      let [error, response] = await to(GoogleHopeService.saveTotem(this.concepts, this.name, {lat: this.latitude, lng: this.longitude}))
      this.error = error
      if (!error) {
        console.log('saved', response)
        this.$emit('update:mode', 'totem')
        this.$emit('totem:save', response.data)
      }
    },
    fillInAddress: function () {
      console.log(this.autocomplete, this.autocomplete.getPlace, this.autocomplete.getPlace())

      let place = this.autocomplete.getPlace()
      this.location = place.formatted_address
      this.latitude = place.geometry.location.lat()
      this.longitude = place.geometry.location.lng()
      // console.log(place.geometry.location.lat(), place.geometry.location.lng())
    }
  }
}
</script>


<style scoped lang="scss">
@import 'variables';

.totem-save-form {
  position: absolute;
  width: 100%;
  height: 100%;
  // background: linear-gradient(to bottom, $c-light-brown, $c-brown);
  z-index: $z-ui;
  text-align: center;
  top: 50px;
  box-sizing: border-box;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @include breakpoint(#{$bp-sm}px) {
    width: 800px;
    height: 500px;
    top: 50%;
    left: 50%;
    overflow-y: auto;
    transform: translate(-50%, -50%);
  }
}

.error {
  color: $c-red;
}

.el-input {
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: 300px;
}

h1 {
  font-size: 25px;
  margin-top: 80px;
  margin-bottom: 80px;
  font-weight: 600;
  color: #8a8a89;
  width: 200px;
  margin-left: auto;
  margin-right: auto;

  @include breakpoint(#{$bp-sm}px) {
    margin-top: 0;
  }
}

.done-btn {
  margin-top: 30px;
}

.gray {
  color: $c-gray;
}

</style>



// WEBPACK FOOTER //
// src/organisms/TotemSaveForm.vue